import { SubSink } from 'subsink';
import { ApiService } from '../../../services/api.service';
import { ProfileListDetailComponent } from '../profile-list-detail/profile-list-detail.component';
import * as _ from 'lodash';
var ProfileListComponent = (function () {
    function ProfileListComponent(apiService) {
        this.apiService = apiService;
        this.itemsPerPage = 40;
        this.searchUsername = '';
        this.groups = [];
        this.currentPage = 1;
        this.loading = false;
        this.list = [];
        this.subs = new SubSink();
    }
    ProfileListComponent.prototype.ngOnInit = function () {
        this.pageChanged();
        this.loadGroups();
    };
    ProfileListComponent.prototype.reload = function () {
        this.pageChanged();
    };
    ProfileListComponent.prototype.pageChanged = function () {
        this.loadData();
    };
    ProfileListComponent.prototype.optionChanged = function () {
        this.search();
    };
    ProfileListComponent.prototype.openModal = function (data, index) {
        this.detailModal.open(this, data);
    };
    ProfileListComponent.prototype.search = function () {
        this.currentPage = 1;
        this.errorMessage = null;
        this.loadData();
    };
    ProfileListComponent.prototype.loadData = function () {
        var _this = this;
        var data = {
            page: this.currentPage,
            items_per_page: this.itemsPerPage,
            username: this.searchUsername
        };
        if (this.searchGroup != null) {
            data['group'] = this.searchGroup;
        }
        this.loading = true;
        this.subs.add(this.apiService.getUsers(data).subscribe(function (res) {
            _this.list = res.results;
            _this.totalItems = res.count;
            _this.loading = false;
        }, function (error) {
            _this.loading = false;
        }));
    };
    ProfileListComponent.prototype.clearSearch = function () {
        this.searchGroup = null;
        this.searchUsername = '';
    };
    ProfileListComponent.prototype.loadGroups = function () {
        var _this = this;
        this.groups = [
            {
                label: 'ทั้งหมด',
                value: null
            }
        ];
        this.subs.add(this.apiService.getGroups().subscribe(function (groups) {
            _.forEach(groups, function (group) {
                _this.groups.push({
                    label: group['name'],
                    value: group['id']
                });
            });
        }, function (error) { }));
    };
    ProfileListComponent.prototype.changePermissionAccess = function (user, accessType) {
        var _this = this;
        var data = {
            user_id: user.id,
            access_type: accessType,
        };
        this.subs.add(this.apiService.setPermissionAccess(data).subscribe(function (res) {
            _this.loadData();
        }, function (error) {
            _this.loadData();
            _this.errorMessage = _this.apiService.getErrorMessage(error);
        }));
    };
    ProfileListComponent.prototype.ngOnDestroy = function () {
        this.subs.unsubscribe();
    };
    return ProfileListComponent;
}());
export { ProfileListComponent };



// WEBPACK FOOTER //
// /opt/app/src/app/features/profile/profile-list/profile-list.component.ts.pre-build-optimizer.js